/* eslint-disable import/named, no-unused-vars */
// eslint doesn't know how to handle typescript type imports
import { format } from 'date-fns';
import { FormatterFunction } from '.';

export const dateFormatter: FormatterFunction = (
  fullMatch: string,
  args: string[],
) => {
  if (!args || args.length !== 2) return fullMatch;
  const [dateFormat, timestamp] = args;
  return format(new Date(Number(timestamp)), dateFormat);
};
